/** @format */

import { addDays, format } from "date-fns";
import { DebouncedFunc } from "lodash";
import { consts } from "../../../common/consts";
import { getDataFromStorage, setDataToStorage } from "../../../common/sessionStorageHelpers";
import IAuthState from "../../../interfaces/IAuthState";

const persistName = "transferSchedule";
const getData = (value = "") => getDataFromStorage(persistName, value);
const setData = (key: string, value: any) => setDataToStorage(persistName, key, value);

const parseTime = (time: any): string => {
  if (typeof time === "string") return time;
  let d = new Date();
  if (time?.hours !== undefined || time?.minutes !== undefined) {
    d.setHours(time?.hours);
    d.setMinutes(time?.minutes);
  } else return "";
  return `${("0" + d.getHours()).slice(-2)}:${("0" + d.getMinutes()).slice(-2)}`;
};

const parseDay = (item: string) => {
  if (!item || item.indexOf("T") < 0) return "";
  item = item.split("T")[0];
  if (format(new Date(), "yyyy-MM-dd") == item) return "today";
  if (format(addDays(new Date(), 1), "yyyy-MM-dd") == item) return "tomorrow";
  return format(new Date(item), "EEEE").toLowerCase();
};

const getRoles = (authStore: IAuthState) => {

  let keyValuePairsArray = authStore?.data?.PermissionScope?.split(", ");
  let keyValuePairs = keyValuePairsArray?.map(pair => {
    const [key, value] = pair?.split("-");
    return { key: key, value };
  });

  const getValueByKey = (key:any) => {
    // Find the key-value pair with the matching key
    const pair = keyValuePairs?.find(pair => pair.key === key);
    // If a matching pair is found, return its value, otherwise return null
    return pair ? pair.value : null;
};

  const permissions = {
    canMakeBooking: authStore?.data?.role?.split(",")?.some((p) => p == consts.Permissions.MakeBooking || p == consts.Permissions.SMAMakeBooking),
    canEditBooking: authStore?.data?.role?.split(",")?.some((p) => p == consts.Permissions.EditBooking || p == consts.Permissions.SMAEditBooking),
    canViewScheduleAsSMA: authStore?.data?.role?.split(",")?.some((p) => p == consts.Permissions.SMAViewSchedule),
    canViewSchedule: authStore?.data?.role?.split(",")?.some((p) => p == consts.Permissions.ViewSchedule),
    canScheduleTransfer: authStore?.data?.role
      ?.split(",")
      ?.some((p) => p == consts.Permissions.SMAScheduleTransfer || p == consts.Permissions.ScheduleTransfer),
    canScheduleTransferAsSMA: authStore?.data?.role?.split(",")?.some((p) => p == consts.Permissions.SMAScheduleTransfer),
    canRequestAdHocTransfer: authStore?.data?.role
      ?.split(",")
      ?.some((p) => p == consts.Permissions.RequestAdHocTransfer || p == consts.Permissions.SMARequestAdHocTransfer),
    canMakeEditBooking:
      authStore?.data?.role?.split(",")?.some((p) => p == consts.Permissions.MakeBooking || p == consts.Permissions.SMAMakeBooking) &&
      authStore?.data?.role?.split(",")?.some((p) => p == consts.Permissions.EditBooking || p == consts.Permissions.SMAEditBooking),
    //canMakeEditBooking: authStore?.data?.role?.split(',')?.some(p => ((p == consts.Permissions.MakeBooking || p == consts.Permissions.SMAMakeBooking) && (p == consts.Permissions.EditBooking || p == consts.Permissions.SMAEditBooking))),
    //canViewDashboard: authStore?.data?.role?.split(',')?.some(p => p == consts.Permissions. || p == consts.Permissions.ScheduleTransfer)
  };
  //console.log(permissions);

  const roles = {
    isAdmin: authStore?.data?.IsAdmin || false,
    SMADriver: authStore?.data ? (authStore?.data?.role?.indexOf(consts.Permissions.SMADriver) >= 0 ? true : false) : false,
    CustomerDriver: authStore?.data ? (authStore?.data?.role?.indexOf(consts.Permissions.CustomerDriver) >= 0 ? true : false) : false,
    isCustomer:authStore.data?.IsCustomer||false,
    isSMAUser:authStore.data?.IsSMAUser||false,
  };
  return {
    assignText: roles.isAdmin || roles.isCustomer || roles.isSMAUser ? "Assign" : (roles.SMADriver || roles.CustomerDriver) ? "Assign To Me" : "",
    hospitalSelectArrow: (roles.isAdmin || permissions.canViewScheduleAsSMA || roles.isCustomer) ? true : false,
    wardSwitch: getValueByKey(consts.Permissions.ViewSchedule)!= null && getValueByKey(consts.Permissions.ViewSchedule) === '1' ? false : true,
    transerSwitch: roles.SMADriver || roles.isAdmin ? true : false,
    transerSwitchRightText: roles.isAdmin ? "Unassigned" : roles.SMADriver ? "Assigned To Me" : "",
    transferCheckboxes: (roles.SMADriver || roles.CustomerDriver),
    isSMADriver: roles.SMADriver,
    isCustomerDriver: roles.CustomerDriver,
    isAdmin: roles.isAdmin,
    adminNavbar: roles.isAdmin,
    canTrackFleet: roles.isAdmin || permissions.canViewScheduleAsSMA,
    canMakeBooking: roles.isAdmin || permissions.canMakeBooking,
    canScheduleTransfer: permissions.canScheduleTransfer,
    canScheduleTransferAsSMA: permissions.canScheduleTransferAsSMA,
    isVehicleAllocated: authStore?.vehicleNumber ? true : false,
    canRequestAdHocTransfer: permissions.canRequestAdHocTransfer || roles.isAdmin,
    canMakeEditBooking: permissions.canMakeEditBooking || roles.isAdmin,
    isCustomer:roles.isCustomer,
    isSMAUser:roles.isSMAUser,
  };
};

const getTransferStatusString = (status: number) => {
  switch (status) {
    case 1:
      return "Requested";
    case 2:
      return "Scheduled";
    case 3:
      return "In Progress";
    case 4:
      return "Complete";

    case 6:
      return "Aborted";
    case 7:
      return "Picking Up";
    case 8:
      return "EnRoute To Destination";
    case 9:
      return "Dropping Off";
    case 10:
      return "Ended";
    case 11:
      return "Cancelled";
    default:
      return "Unknown";
  }
};

const hubMessageHandler = async (
  showAnimation: boolean,
  selectedLocations: any[],
  selectedDay: any,
  updatedTransferId: string,
  updatedTransfersRef: any,
  setUpdatedTransfers: any,
  customerId:any,
  getScheduleList: DebouncedFunc<(showAll: boolean, filter: any) => Promise<void>>
): Promise<void> => {
  await getScheduleList(false, { locations: selectedLocations, scheduledDate: selectedDay,Customerid:customerId, version: Math.random().toString()+Math.random().toString()+Math.random().toString() });
  if (showAnimation) {
    let updatedTransfers = updatedTransfersRef.current as any[];
    let now = new Date();
    if (updatedTransfers.find((e) => e.TransferId === updatedTransferId)) {
      let newUpdatedTransfers = updatedTransfers.map((obj) => {
        if (obj.TransferId === updatedTransferId) {
          return {
            TransferId: updatedTransferId,
            UpdatedDate: now,
          };
        } else {
          return obj;
        }
      });
      updatedTransfersRef.current = newUpdatedTransfers;
      setUpdatedTransfers(newUpdatedTransfers);
    } else {
      let newUpdatedTransfers = [
        ...updatedTransfers,
        {
          TransferId: updatedTransferId,
          UpdatedDate: now,
        },
      ];
      updatedTransfersRef.current = newUpdatedTransfers;
      setUpdatedTransfers(newUpdatedTransfers);
    }
  }
};

const getBearingAngle = (lat1: number | null, lng1: number | null, lat2: number | null, lng2: number | null) => {
  if (!lat1 || !lng1 || !lat2 || !lng2) return null;
  var dLon = lng2 - lng1;
  var y = Math.sin(dLon) * Math.cos(lat2);
  var x = Math.cos(lat1) * Math.sin(lat2) - Math.sin(lat1) * Math.cos(lat2) * Math.cos(dLon);
  var brng = (Math.atan2(y, x) * 180) / Math.PI;
  return 360 - ((brng + 360) % 360);
};

const getRequestedStatusString = (row: any) => {
  let onStr = "on ";
  const dayStr = parseDay(row.bookingDate);
  if (dayStr == "today" || dayStr == "tomorrow") {
    onStr = "";
  }
  if (!row.mainTransfer) {
    return "Return transfer";
  } else if (row?.anyTimeOfTheDay === true) {
    return `Any time ${onStr}${dayStr}`;
  }else if (row?.pickupAfterTime && row?.pickupBeforeTime) {
    return `Pickup after ${parseTime(row.pickupAfterTime)} and before ${parseTime(row.pickupBeforeTime)} ${onStr}${dayStr}`;
  } else if (row?.pickupAfterTime) {
    return `Pickup after ${parseTime(row.pickupAfterTime)} ${dayStr}`;
  } else if (row?.pickupBeforeTime) {
    return `Pickup before ${parseTime(row.pickupBeforeTime)} ${dayStr}`;
  } else if (row?.dropoffAfterTime && row?.dropoffBeforeTime) {
    return `Dropoff after ${parseTime(row.dropoffAfterTime)} and before ${parseTime(row.dropoffBeforeTime)} ${onStr}${dayStr}`;
  } else if (row?.dropoffAfterTime) {
    return `Dropoff after ${parseTime(row.dropoffAfterTime)} ${dayStr}`;
  } else if (row?.dropoffBeforeTime) {
    return `Dropoff before ${parseTime(row.dropoffBeforeTime)} ${dayStr}`;
  }  else return "";
};

export {
  parseTime,
  parseDay,
  getRoles,
  getData,
  setData,
  getTransferStatusString,
  hubMessageHandler,
  persistName,
  getBearingAngle,
  getRequestedStatusString,
};
